import React, { Fragment, useState, useEffect } from "react";
import { connectAdvanced, useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

import DoNotDisturbOnRoundedIcon from "@mui/icons-material/DoNotDisturbOnRounded";

import TextFieldTheme from "../../../../shared/general/TextFieldTheme";
import ButtonBlue from "../../../../shared/general/ButtonBlue";
import DrawerCustom from "../../../../shared/general/Drawer";

import {
  postGroupGpsLocations,
  getAllLocations,
  updateGroupGpsLocations,
} from "../../../../../../actions/gpsLocations";

import FormGpsPositions from "./FormGpsPositions";
import { Typography } from "@mui/material";

const StyledRoot = styled("div")({
  width: 350,
  padding: 24,
  "& .wrap-form": {
    marginBottom: 16,
  },
  "& .wrap-action": {
    display: "flex",
    justifyContent: "flex-end",
  },
});

const StyleWrapForm = styled("div")({
  "&.top": {
    paddingTop: 16,
  },
});

const StyledContentLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
});

const DialogGpsLocations = (props) => {
  const {
    open,
    method,
    mode,
    selectedGroup,
    handleClose,
    handleOpenAlert,
    handleChangeAlertType,
  } = props;
  const dispatch = useDispatch();
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (mode === "edit" && method === "group") {
      console.log("selectedGroup: ", selectedGroup);
      setFormData(selectedGroup);
    } else {
      setFormData({
        name: "",
        isActive: true,
      })
    }
  }, [mode, method]);

  const handleSaveGroupGpsLocations = async (isDelete) => {
    if (userProfile) {
      let formDataRequest = { ...formData };
      let result = null;
      if (mode === "edit") {
        formDataRequest.updateBy = userProfile.idEmployees;
        formDataRequest.isActive = !(isDelete === "delete");
        result = await dispatch(updateGroupGpsLocations(formDataRequest));
      } else {
        formDataRequest.createDate = dayjs(new Date()).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        formDataRequest.createBy = userProfile.idEmployees;
        formDataRequest.idCompany = userProfile.idCompany;
        result = await dispatch(postGroupGpsLocations(formData));
      }

      if (result) {
        handleOpenAlert();
        if (result.status === 200) {
          handleChangeAlertType("success");
          if (userProfile) {
            dispatch(getAllLocations(userProfile.idCompany));
          }
        } else {
          handleChangeAlertType(result.data.message);
        }
        handleClose();
      } else {
        handleOpenAlert();
        handleChangeAlertType("error");
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  return (
    <DrawerCustom
      title={`${mode === "edit" ? "แก้ไข" : "เพิ่ม"}กลุ่มพื้นที่/ตำแหน่ง`}
      anchor={"right"}
      open={open}
      onClose={handleClose}
    >
      <StyledRoot>
        {method === "group" ? (
          <Fragment>
            <div className="wrap-form">
              {mode === "edit" && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <ButtonBlue
                    variant="contained"
                    color="error"
                    size="small"
                    startIcon={<DoNotDisturbOnRoundedIcon />}
                    onClick={() => handleSaveGroupGpsLocations("delete")}
                  >
                    ปิดการใช้งาน
                  </ButtonBlue>
                </div>
              )}
              <StyleWrapForm className={mode === "edit" ? "top" : ""}>
                <StyledContentLabel color="text.third" gutterBottom>
                  ชื่อกลุ่มพื้นที่/ตำแหน่ง
                </StyledContentLabel>
                <TextFieldTheme
                  name="name"
                  multiline
                  rows={2}
                  value={formData.name}
                  onChange={handleChange}
                />
              </StyleWrapForm>
            </div>
            <div className="wrap-action">
              <ButtonBlue onClick={handleClose} variant={"text"}>
                ยกเลิก
              </ButtonBlue>
              <ButtonBlue
                onClick={handleSaveGroupGpsLocations}
                variant={"contained"}
                autoFocus
              >
                บันทึกข้อมูล
              </ButtonBlue>
            </div>
          </Fragment>
        ) : (
          <FormGpsPositions
            mode={mode}
            selectedGroup={selectedGroup}
            handleOpenAlert={handleOpenAlert}
            handleChangeAlertType={handleChangeAlertType}
            handleClose={handleClose}
          />
        )}
      </StyledRoot>
    </DrawerCustom>
  );
};

export default DialogGpsLocations;
